export default `
mutation registerLicensePlate($input: WmLicensePlateRegisterInput!) {
  wmLicensePlateRegister(input: $input) {
    uid
    brand
    model
    info
    license_plate
  }
}
`